import itemCard from './item-card';

export default itemCard;
